import { render } from "./ShortPageForm.vue?vue&type=template&id=fae368aa&ts=true"
import script from "./ShortPageForm.vue?vue&type=script&lang=ts"
export * from "./ShortPageForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__